import FeatureToggler from './directives/FeatureToggler';

export default angular.module('edge.platform.featuredetection', [])
    .directive('gwFeatureToggler', FeatureToggler);